import { FaUser, FaMapMarkerAlt, FaClock, FaTruck, FaWhatsapp, FaShieldAlt, FaLeaf, FaTrophy, FaHeart } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { WishlistContext } from "../../Context/WishlistContext";
import { MdLocalShipping, MdVerified } from "react-icons/md";
import React, { useContext, useState, useEffect } from "react";
import "./ProductDisplay.css";
import logo from "../Assets/logo-04.png";
import quality_icon from "../Assets/quality.png";
import money_icon from "../Assets/save-money.png";
import trust_icon from "../Assets/trust.png";
import { ShopContext } from "../../Context/ShopContext";
import { backend_url, currency } from "../../App";
import About from "../About/About";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OrderPopup from "../OrderPopUp/OrderPopUp";
import { Link, useNavigate } from "react-router-dom";
import EstimatorModal from "./EstimatorModal";
import EstimatorImage1 from "../Assets/est-1.jpeg";
import EstimatorImage2 from "../Assets/est-2.jpeg";
import useSiteContent from "../../utils/useSiteContent";
import { PRODUCT_TABS_DEFAULTS } from "../../Constants/productTabsContent";
import { makeCartKey } from "../../utils/cartKey";

const Products = ({ product }) => {
  const navigate = useNavigate();
  const isAuthorize = !!localStorage.getItem("auth-token");

  const [count, setCount] = useState(1);
  const [activeTab, setActiveTab] = useState("description");
  // Tab names/text/images are editable in Admin → HomePage → Product Page Tabs
  const tabText = useSiteContent("product-tabs", PRODUCT_TABS_DEFAULTS);
  const { addToCart, cartItems, deleteFromCart } = useContext(ShopContext);
  const { toggleWishlist, isWishlisted } = useContext(WishlistContext);
  const wishlisted = isWishlisted(product?.id);
  const selectedColor = product?.colors?.[0] ?? null;
  const [selectedImage, setSelectedImage] = useState(
    product?.colors?.[0]?.images?.[0] || product?.images?.[0]
  );
  const galleryImages =
    selectedColor?.images?.length ? selectedColor.images : product.images;

  const [zoomStyle, setZoomStyle] = useState({});
  const [mobileGalleryIndex, setMobileGalleryIndex] = useState(0);
  const [selectedSize, setSelectedSize] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [showRequestForm, setShowRequestForm] = useState(false);
  const [requestQty, setRequestQty] = useState(1);
  const [requestNote, setRequestNote] = useState("");

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("auth-token");
        if (!token) return;
        const response = await fetch(`${backend_url}/getuserdetails`, {
          method: "GET",
          headers: { "auth-token": token },
        });
        const data = await response.json();
        if (data.success) setUserDetails(data.user);
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };
    fetchUserDetails();
  }, []);

  const handlePopupNow = () => {
    if (!isAuthorize) {
      toast.info("Please Login/Register to continue with your order");
      const from = window.location.pathname + window.location.search;
      setTimeout(() => navigate("/login", { state: { from } }), 1500);
      return;
    }
    setShowPopup(true);
  };

  const handleInputChange = (e) => {
    const value = parseFloat(e.target.value);
    const maxQty = product?.quantity || Infinity;
    if (!isNaN(value) && value >= 0.5) setCount(Math.min(value, maxQty));
  };

  const closePopup = () => setShowPopup(false);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setZoomStyle({ transformOrigin: `${x}% ${y}%`, transform: "scale(2)", transition: "transform 0.1s ease" });
  };

  const handleMouseLeave = () => setZoomStyle({ transform: "scale(1)" });

  const discountPercentage = product.new_price;
  const newPrice = product.old_price
    ? (product.old_price * (100 - discountPercentage)) / 100
    : product.new_price;

  const step = product.scale?.toLowerCase() === "meters" ? 0.5 : 1;
  const minVal = step;

  // Stock tiers differ by unit:
  // - Meters (fabric): < 1 = Out of Stock (Restocking Soon), 1–14 = Low Stock (still sold), 15+ = In-Stock
  // - Pieces (sarees etc.): follow the Status set in admin; fall back to qty 0 = Out
  const qty = Number(product.quantity) || 0; // API may send quantity as a string
  const isMeters = product.scale?.toLowerCase() === "meters";
  const STATUS_LEVEL = { "in-stock": "in", "low stock": "low", "out of stock": "out" };
  const statusLevel = STATUS_LEVEL[String(product.status || "").trim().toLowerCase()];
  const stockLevel = isMeters
    ? qty < 1 ? "out" : qty < 15 ? "low" : "in"
    : statusLevel || (qty < 1 ? "out" : "in");
  // A fabric that has run out is shown as "Restocking Soon" (soft) with an enquiry,
  // instead of a hard "Out of Stock".
  const isRestocking = isMeters && stockLevel === "out";
  const STOCK_CONFIG = {
    out: { label: "Out of Stock", dot: "bg-red-500", badge: "bg-red-500" },
    low: { label: "Low Stock", dot: "bg-orange-500", badge: "bg-orange-500" },
    in: { label: "In Stock", dot: "bg-green-500", badge: "bg-[var(--brand-primary-600)]" },
    restock: { label: "Out of Stock · Restocking Soon", dot: "bg-red-500", badge: "bg-red-500" },
  };
  const stockInfo = STOCK_CONFIG[isRestocking ? "restock" : stockLevel];
  const isBuyable = stockLevel !== "out";

  const tabs = [
    { id: "description", label: tabText.descTab },
    tabText.showEstimator && (tabText.estimatorFor !== "fabrics" || isMeters) && { id: "estimator", label: tabText.estimatorTab },
    tabText.showShipping && { id: "shipping", label: tabText.shippingTab },
    tabText.showWashcare && { id: "washcare", label: tabText.washcareTab },
  ].filter(Boolean);
  // if the open tab gets switched off, fall back to Description
  const shownTab = tabs.some((t) => t.id === activeTab) ? activeTab : "description";

  const descFields = [
    { label: "Description", value: product.description },
    { label: "Material", value: product.material },
    { label: "Width", value: product.size },
    { label: "Weight", value: product.weight },
    { label: "Quality", value: product.quality },
    { label: "Color", value: product.color },
    { label: "Wash Care", value: product.washcare },
    { label: "Disclaimer", value: product.disclaimer },
    { label: "Note", value: product.note },
    { label: "Mktg. / Mfg. By", value: "Aavaryaa's FabHub" },
  ];

  return (
    <>
      <div
        className="md:min-h-screen px-6 sm:px-10 lg:px-24 xl:px-36 py-10"
        style={{ background: "linear-gradient(180deg, var(--brand-surface) 0%, var(--brand-bg) 60%)" }}
      >
        {/* Subtle dot grid */}
        <div
          className="fixed inset-0 opacity-[0.025] pointer-events-none z-0"
          style={{
            backgroundImage: "radial-gradient(circle, var(--brand-primary-600) 1px, transparent 1px)",
            backgroundSize: "28px 28px",
          }}
        />

        <div className="relative z-10 max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-12 xl:gap-16">

            {/* ── Left: Images (sticky so the photo stays in view while
                 scrolling the longer details column) ── */}
            <div className="flex flex-col gap-4 lg:sticky lg:top-4 lg:self-start">
              {/* Main image — desktop/tablet (hover-zoom + thumbnail grid) */}
              <div
                className="hidden md:block relative overflow-hidden rounded-3xl shadow-xl"
                style={{ cursor: "crosshair" }}
              >
                <img
                  crossOrigin="anonymous"
                  src={selectedImage || product.images[0]}
                  alt="Selected Product"
                  className="w-full h-[620px] lg:h-[540px] object-cover"
                  onMouseMove={handleMouseMove}
                  onMouseLeave={handleMouseLeave}
                  style={zoomStyle}
                  loading="lazy"
                />
                {/* Zoom hint */}
                <div className="absolute bottom-3 right-3 bg-black/40 text-white text-[10px] px-2 py-1 rounded-full backdrop-blur-sm">
                  🔍 Hover to zoom
                </div>
                {/* Bestseller ribbon */}
                {product.bestseller?.toLowerCase() === "yes" && (
                  <div
                    className="absolute top-4 left-0 text-white text-xs font-bold px-4 py-1 rounded-r-full shadow"
                    style={{ background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-secondary-500))" }}
                  >
                    ⭐ BESTSELLER
                  </div>
                )}
              </div>

              {/* Thumbnails — desktop/tablet only */}
              <div className="hidden md:grid grid-cols-4 gap-2.5">
                {galleryImages.slice(0, 4).map((item, i) => (
                  <div
                    key={i}
                    onClick={() => setSelectedImage(item)}
                    className={`overflow-hidden rounded-2xl cursor-pointer border-2 transition-all duration-200
                      ${selectedImage === item
                        ? "border-[var(--brand-primary-500)] shadow-md shadow-[var(--brand-primary-200)]"
                        : "border-gray-100 hover:border-[var(--brand-primary-300)]"}`}
                  >
                    <img
                      crossOrigin="anonymous"
                      src={item}
                      alt={`Thumbnail ${i + 1}`}
                      className="w-full h-24 lg:h-20 object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                ))}
              </div>

              {/* Mobile: swipeable gallery (native scroll-snap, no hover needed) */}
              <div className="md:hidden">
                <div
                  className="relative overflow-hidden rounded-3xl shadow-xl"
                >
                  <div
                    className="flex overflow-x-auto snap-x snap-mandatory scroll-smooth scrollbar-hide"
                    onScroll={(e) => {
                      const w = e.currentTarget.clientWidth || 1;
                      const idx = Math.round(e.currentTarget.scrollLeft / w);
                      setMobileGalleryIndex(idx);
                    }}
                  >
                    {galleryImages.map((item, i) => (
                      <img
                        key={i}
                        crossOrigin="anonymous"
                        src={item}
                        alt={`${product.name} ${i + 1}`}
                        className="w-full flex-shrink-0 snap-center h-[420px] object-cover"
                        loading="lazy"
                      />
                    ))}
                  </div>
                  {product.bestseller?.toLowerCase() === "yes" && (
                    <div
                      className="absolute top-4 left-0 text-white text-xs font-bold px-4 py-1 rounded-r-full shadow"
                      style={{ background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-secondary-500))" }}
                    >
                      ⭐ BESTSELLER
                    </div>
                  )}
                </div>
                {galleryImages.length > 1 && (
                  <div className="flex justify-center gap-1.5 mt-2.5">
                    {galleryImages.map((_, i) => (
                      <span
                        key={i}
                        className={`h-1.5 rounded-full transition-all ${
                          i === mobileGalleryIndex
                            ? "w-5 bg-[var(--brand-primary-600)]"
                            : "w-1.5 bg-[var(--brand-primary-200)]"
                        }`}
                      />
                    ))}
                  </div>
                )}
              </div>

              {/* WhatsApp enquiry */}
              <a
                href={`https://wa.me/919789389489?text=Hi%2C%20I%27m%20interested%20in%20${encodeURIComponent(product.name || "this product")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl border-2 border-green-500 text-green-700 font-semibold text-sm hover:bg-green-50 transition"
              >
                <FaWhatsapp size={16} />
                Enquire on WhatsApp
              </a>

              {/* Add to Cart / Buy Now — mobile only, sits right below the
                  WhatsApp enquiry button instead of floating over the page */}
              <div className="md:hidden bg-white rounded-2xl border border-[var(--brand-primary-100)] shadow-sm p-3 flex flex-col gap-2.5">
                {/* Price + quantity stepper */}
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-lg font-bold text-gray-800 leading-tight">{currency}{newPrice.toFixed(2)}</p>
                    <p className="text-[11px] text-gray-500 leading-tight">/{product.scale === "Meters" ? "meter" : "piece"}</p>
                  </div>
                  {isMeters && (
                  <div className={`flex items-center rounded-xl overflow-hidden border-2 ${
                    isBuyable ? "border-[var(--brand-primary-200)] bg-white" : "border-gray-200 bg-gray-100"
                  }`}>
                    <button
                      className={`px-3 py-1.5 font-bold text-base ${
                        isBuyable ? "text-[var(--brand-primary-700)]" : "text-gray-300"
                      }`}
                      onClick={() => setCount(count > minVal ? count - step : minVal)}
                      disabled={!isBuyable}
                    >
                      −
                    </button>
                    <span className={`w-8 text-center text-sm font-semibold ${isBuyable ? "text-gray-800" : "text-gray-400"}`}>
                      {count}
                    </span>
                    <button
                      className={`px-3 py-1.5 font-bold text-base ${
                        isBuyable ? "text-[var(--brand-primary-700)]" : "text-gray-300"
                      }`}
                      onClick={() => setCount(Math.min(count + step, qty || count + step))}
                      disabled={!isBuyable}
                    >
                      +
                    </button>
                  </div>
                  )}
                </div>

                {/* Actions — both filled so they read as one visual weight */}
                <div className="flex items-center gap-2">
                  {cartItems[makeCartKey(product.id, selectedColor?._id)] > 0 ? (
                    <button
                      className="flex-1 py-3 rounded-xl bg-red-50 text-red-600 font-bold text-xs active:scale-95 transition-transform"
                      onClick={() => deleteFromCart(makeCartKey(product.id, selectedColor?._id))}
                    >
                      ✕ Remove
                    </button>
                  ) : (
                    <button
                      className={`flex-1 py-3 rounded-xl font-bold text-xs active:scale-95 transition-transform ${
                        isBuyable ? "text-[var(--brand-primary-700)] bg-[var(--brand-primary-50)] border-2 border-[var(--brand-primary-200)]" : "bg-gray-200 text-gray-400"
                      }`}
                      disabled={!isBuyable}
                      onClick={isBuyable ? () => addToCart(makeCartKey(product.id, selectedColor?._id), count) : null}
                    >
                      🛒 Add to Cart
                    </button>
                  )}
                  <button
                    className={`flex-1 py-3 rounded-xl font-bold text-xs active:scale-95 transition-transform ${
                      isBuyable ? "text-white shadow" : "bg-gray-200 text-gray-400"
                    }`}
                    style={isBuyable ? { background: "linear-gradient(90deg, var(--brand-primary-700), var(--brand-secondary-600))" } : {}}
                    onClick={isBuyable ? handlePopupNow : null}
                    disabled={!isBuyable}
                  >
                    {isBuyable ? "⚡ Buy Now" : "Sold Out"}
                  </button>
                </div>
              </div>
            </div>

            {/* ── Right: Details ── */}
            <div className="flex flex-col gap-4">

              {/* Design ID + Status */}
              <div className="flex items-center flex-wrap gap-2">
                {/* plain chip in the theme colour (was fixed grey) */}
                <span className="text-xs font-mono font-semibold px-3 py-1 rounded-full bg-white border border-[var(--brand-primary-200)] text-[var(--brand-primary-700)]">
                  Design ID: {product.unique_id}
                </span>
                <span
                  className={`text-xs text-white px-3 py-1 rounded-full font-semibold ${stockInfo.badge}`}
                >
                  {isRestocking ? "🔄 " : stockLevel === "out" ? "✗ " : "✓ "}
                  {stockInfo.label}
                </span>
                {product.bestseller?.toLowerCase() === "yes" && (
                  <span className="text-xs text-white bg-yellow-500 px-3 py-1 rounded-full font-semibold">
                    🏆 BESTSELLER
                  </span>
                )}
              </div>

              {/* Product name + wishlist */}
              <div className="flex items-start justify-between gap-3">
                <h1
                  className="text-xl sm:text-2xl font-bold text-gray-900 leading-snug"
                  style={{ fontFamily: "'Times New Roman', serif" }}
                >
                  {product.name}
                </h1>
                <button
                  onClick={() => toggleWishlist({ id: product.id, name: product.name, image: product.images?.[0] || "", new_price: newPrice.toFixed(2) })}
                  className="shrink-0 w-10 h-10 rounded-full flex items-center justify-center shadow-md transition-all duration-200 hover:scale-110 active:scale-95 mt-0.5"
                  style={{
                    background: wishlisted ? "linear-gradient(135deg,var(--brand-primary-600),var(--brand-primary-500))" : "var(--brand-primary-50)",
                    border: wishlisted ? "none" : "1.5px solid var(--brand-primary-100)",
                  }}
                  title={wishlisted ? "Remove from wishlist" : "Save to wishlist"}
                >
                  {wishlisted
                    ? <FaHeart size={15} color="white" />
                    : <FiHeart size={15} style={{ color: "var(--brand-primary-600)" }} />
                  }
                </button>
              </div>

              {/* Price block */}
              <div className="rounded-2xl p-4 border border-[var(--brand-primary-100)] bg-[var(--brand-primary-50)]/60">
                <div className="flex items-center flex-wrap gap-3">
                  <span className="text-2xl font-bold text-[var(--brand-primary-700)]">
                    {currency}{newPrice.toFixed(2)}
                  </span>
                  {product.old_price && (
                    <>
                      <span className="text-gray-400 line-through text-sm">
                        {currency}{product.old_price}
                      </span>
                      <span className="bg-green-100 text-green-700 text-xs font-bold px-2.5 py-1 rounded-full">
                        {discountPercentage}% OFF
                      </span>
                    </>
                  )}
                  <span className="text-gray-500 text-sm">
                    /{product.scale === "Meters" ? "meter" : "piece"}
                  </span>
                </div>
                <p className="text-xs text-gray-400 mt-1">
                  M.R.P: <span className="line-through">{currency}{product.old_price}</span>
                  &nbsp;·&nbsp; Inclusive of all taxes
                </p>
              </div>

              {/* Stock info */}
              <p className="text-sm text-gray-600 flex items-center gap-1.5">
                <span className={`w-2 h-2 rounded-full ${stockInfo.dot}`} />
                <span className="font-medium">{qty}</span>
                {product.scale === "Meters" ? " meters" : " pieces"} in stock
                <span className="text-xs text-gray-400">· {stockInfo.label}</span>
              </p>

              {/* Restocking note (fabrics that hit zero) */}
              {isRestocking && (
                <p className="text-sm text-orange-700 bg-orange-50 border border-orange-200 rounded-xl px-4 py-2.5 flex items-center gap-2">
                  <span>🔄</span>
                  This fabric is currently out — <span className="font-semibold">we'll restock it soon</span>. Send an enquiry below and we'll notify you.
                </p>
              )}

              {/* Quantity selector — fabrics only; sarees/pieces are sold one at a time */}
              {isMeters && (
              <div className="flex items-center gap-4 flex-wrap">
                <div className={`flex items-center rounded-xl overflow-hidden border-2 shadow-sm ${
                  isBuyable ? "border-[var(--brand-primary-200)] bg-white" : "border-gray-200 bg-gray-100"
                }`}>
                  <button
                    className={`px-4 py-2.5 font-bold transition text-lg ${
                      isBuyable ? "text-[var(--brand-primary-700)] hover:bg-[var(--brand-primary-50)]" : "text-gray-300 cursor-not-allowed"
                    }`}
                    onClick={() => setCount(count > minVal ? count - step : minVal)}
                    disabled={!isBuyable}
                  >
                    −
                  </button>
                  <input
                    type="number"
                    value={count}
                    onChange={handleInputChange}
                    className={`w-16 text-center outline-none text-sm font-semibold ${
                      isBuyable ? "text-gray-800 bg-white" : "text-gray-400 bg-gray-100 cursor-not-allowed"
                    }`}
                    step={step}
                    min={minVal}
                    disabled={!isBuyable}
                  />
                  <button
                    className={`px-4 py-2.5 font-bold transition text-lg ${
                      isBuyable ? "text-[var(--brand-primary-700)] hover:bg-[var(--brand-primary-50)]" : "text-gray-300 cursor-not-allowed"
                    }`}
                    onClick={() => setCount(Math.min(count + step, qty || count + step))}
                    disabled={!isBuyable}
                  >
                    +
                  </button>
                </div>
                <span className="text-sm text-gray-500">
                  Quantity in meters
                </span>
              </div>
              )}

              {/* CTA buttons — desktop/tablet (mobile uses the sticky bottom bar instead) */}
              <div className="max-md:hidden flex flex-col sm:flex-row gap-3">
                {cartItems[makeCartKey(product.id, selectedColor?._id)] > 0 ? (
                  <button
                    className="flex-1 py-3 rounded-xl border-2 border-red-400 text-red-500 font-bold text-sm hover:bg-red-500 hover:text-white transition-all duration-300"
                    onClick={() => deleteFromCart(makeCartKey(product.id, selectedColor?._id))}
                  >
                    ✕ REMOVE FROM CART
                  </button>
                ) : (
                  <button
                    className={`flex-1 py-3 rounded-xl font-bold text-sm transition-all duration-200 ${
                      isBuyable
                        ? "text-white shadow-lg hover:opacity-90 hover:scale-[1.02] active:scale-[0.98]"
                        : "bg-gray-200 text-gray-400 cursor-not-allowed"
                    }`}
                    style={isBuyable ? { background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-secondary-500))" } : {}}
                    disabled={!isBuyable}
                    onClick={isBuyable ? () => addToCart(makeCartKey(product.id, selectedColor?._id), count) : null}
                  >
                    🛒 ADD TO CART
                  </button>
                )}
                <button
                  className={`flex-1 py-3 rounded-xl font-bold text-sm transition-all duration-200 ${
                    isBuyable
                      ? "text-white shadow-lg hover:opacity-90 hover:scale-[1.02] active:scale-[0.98]"
                      : "bg-gray-200 text-gray-400 cursor-not-allowed"
                  }`}
                  style={isBuyable ? { background: "linear-gradient(90deg, var(--brand-primary-700), var(--brand-secondary-600))" } : {}}
                  onClick={isBuyable ? handlePopupNow : null}
                  disabled={!isBuyable}
                >
                  {isBuyable ? "⚡ BUY NOW" : isRestocking ? "🔄 RESTOCKING SOON" : "OUT OF STOCK"}
                </button>
              </div>

              {/* Request block — shown when out of stock, or when the buyer
                  wants more than what's currently available */}
              {(!isBuyable || count >= qty) && (
                <div className="rounded-2xl border border-[var(--brand-primary-100)] bg-[var(--brand-primary-50)]/50 p-4">
                  {!showRequestForm ? (
                    <button
                      onClick={() => {
                        setShowRequestForm(true);
                        setRequestQty(!isBuyable ? (isMeters ? 6 : 1) : qty + step);
                      }}
                      className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl border-2 border-[var(--brand-primary-400)] text-[var(--brand-primary-700)] font-semibold text-sm hover:bg-[var(--brand-primary-100)] transition"
                    >
                      {!isBuyable
                        ? "📩 Request This Item"
                        : `Need more than ${qty} ${isMeters ? "meters" : qty === 1 ? "piece" : "pieces"}? 📩 Request It`}
                    </button>
                  ) : (
                    <div className="flex flex-col gap-3">
                      <p className="text-sm font-semibold text-[var(--brand-primary-800)]">
                        Tell us how much you need — we'll check with the shop and get back to you.
                      </p>

                      <div className="flex items-center gap-3">
                        <label className="text-xs font-medium text-gray-600 whitespace-nowrap">
                          Quantity needed ({product.scale === "Meters" ? "meters" : "pieces"})
                        </label>
                        <input
                          type="number"
                          min={step}
                          step={step}
                          value={requestQty}
                          onChange={(e) => setRequestQty(e.target.value)}
                          className="w-24 border border-[var(--brand-primary-200)] rounded-lg px-3 py-2 text-sm text-center focus:ring-2 focus:ring-[var(--brand-primary-400)] outline-none bg-white"
                        />
                      </div>

                      <textarea
                        value={requestNote}
                        onChange={(e) => setRequestNote(e.target.value)}
                        placeholder="Any notes for the shop (e.g. preferred delivery date, color match, urgency)"
                        rows={3}
                        className="w-full border border-[var(--brand-primary-200)] rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[var(--brand-primary-400)] outline-none bg-white resize-none"
                      />

                      <div className="flex gap-3">
                        <a
                          href={`https://wa.me/919789389489?text=${encodeURIComponent(
                            `Hi, I'd like to request restock for "${product.name}" (Design ID: ${product.unique_id}).\n` +
                            `Quantity needed: ${requestQty} ${product.scale === "Meters" ? "meters" : "pieces"}\n` +
                            (requestNote ? `Note: ${requestNote}` : "")
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => toast.success("Opening WhatsApp to send your request…")}
                          className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-white font-bold text-sm shadow-lg hover:opacity-90 transition"
                          style={{ background: "linear-gradient(90deg, #25D366, #128C7E)" }}
                        >
                          <FaWhatsapp size={16} /> Send Request
                        </a>
                        <button
                          onClick={() => setShowRequestForm(false)}
                          className="px-4 py-2.5 rounded-xl border border-gray-300 text-gray-500 text-sm font-medium hover:bg-gray-50 transition"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Trust badges */}
              <div className="rounded-2xl border border-[var(--brand-primary-100)] bg-white p-4">
                <p className="text-xs font-bold uppercase tracking-widest text-[var(--brand-primary-500)] mb-3">
                  When you choose Aavryaa
                </p>
                <div className="grid grid-cols-3 gap-3">
                  {[
                    { icon: quality_icon, label: "Exceptional Quality" },
                    { icon: money_icon, label: "Value For Money" },
                    { icon: trust_icon, label: "Trust Of Brand" },
                  ].map(({ icon, label }) => (
                    <div key={label} className="flex flex-col items-center gap-1.5 bg-[var(--brand-primary-50)] rounded-xl p-2.5 text-center">
                      <img crossOrigin="anonymous" src={icon} className="w-7 h-7" alt={label} />
                      <p className="text-[11px] font-semibold text-gray-700 leading-tight">{label}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Delivery info strip */}
              <div className="flex flex-wrap gap-3 text-xs text-gray-600">
                {[
                  { icon: <MdLocalShipping className="text-[var(--brand-primary-500)]" />, text: "Free shipping on orders ₹999+" },
                  { icon: <MdVerified className="text-green-500" />, text: "100% Genuine fabric" },
                  { icon: <FaShieldAlt className="text-[var(--brand-primary-400)]" />, text: "7-day returns" },
                ].map(({ icon, text }) => (
                  <div key={text} className="flex items-center gap-1.5 bg-gray-50 border border-gray-100 rounded-full px-3 py-1.5">
                    {icon}
                    <span>{text}</span>
                  </div>
                ))}
              </div>

              {/* Tabs */}
              <div className="mt-2">
                <div className="flex gap-1 border-b border-[var(--brand-primary-100)] overflow-x-auto">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`whitespace-nowrap pb-3 px-4 text-sm font-semibold tracking-wide transition-all ${
                        shownTab === tab.id
                          ? "border-b-2 border-[var(--brand-primary-600)] text-[var(--brand-primary-700)]"
                          : "text-gray-400 hover:text-[var(--brand-primary-400)]"
                      }`}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>

                <div className="mt-4">
                  {shownTab === "description" && (
                    <div className="rounded-2xl overflow-hidden border border-[var(--brand-primary-100)]">
                      {descFields.filter(f => f.value).map(({ label, value }, i) => (
                        <div
                          key={label}
                          className="flex gap-4 px-4 py-3.5 border-b border-gray-50 last:border-b-0"
                          style={{ background: i % 2 === 0 ? "var(--brand-primary-50)" : "#ffffff" }}
                        >
                          <span className="text-sm font-bold text-[var(--brand-primary-600)] w-36 flex-shrink-0 leading-relaxed">
                            {label}
                          </span>
                          <span className="text-sm text-gray-700 leading-relaxed">{value}</span>
                        </div>
                      ))}
                    </div>
                  )}

                  {shownTab === "estimator" && (
                    <div className="space-y-3">
                      <p className="text-sm text-gray-600">{tabText.estimatorText}</p>
                      <button
                        onClick={() => setOpenModal(true)}
                        className="py-2.5 px-6 rounded-xl text-white text-sm font-semibold shadow hover:opacity-90 transition"
                        style={{ background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-secondary-500))" }}
                      >
                        {tabText.estimatorButton}
                      </button>
                      <EstimatorModal
                        isOpen={openModal}
                        onClose={() => setOpenModal(false)}
                        image1={tabText.estimatorImage || EstimatorImage1}
                        image2={tabText.estimatorImage ? null : EstimatorImage2}
                        title={tabText.estimatorTitle}
                        note={tabText.estimatorNote}
                        noteBold={tabText.estimatorNoteBold}
                      />
                    </div>
                  )}

                  {shownTab === "shipping" && (
                    <div className="space-y-3">
                      <div className="flex items-start gap-3 p-4 bg-[var(--brand-primary-50)] rounded-2xl border border-[var(--brand-primary-100)]">
                        <MdLocalShipping className="text-[var(--brand-primary-500)] text-2xl mt-0.5 flex-shrink-0" />
                        <div>
                          <p className="font-bold text-gray-800 text-sm mb-1">{tabText.shippingTitle}</p>
                          <p className="text-sm text-gray-600">{tabText.shippingText}</p>
                        </div>
                      </div>
                      {tabText.shippingImage && (
                        <img src={tabText.shippingImage} alt={tabText.shippingTitle} loading="lazy"
                          className="w-full max-h-72 object-contain rounded-2xl border border-[var(--brand-primary-100)] bg-white" />
                      )}
                    </div>
                  )}

                  {shownTab === "washcare" && (
                    <div className="p-4 bg-[var(--brand-primary-50)] rounded-2xl border border-[var(--brand-primary-100)]">
                      <p className="font-bold text-sm text-[var(--brand-primary-700)] mb-2">{tabText.washcareTitle}</p>
                      {tabText.washcareImage && (
                        <img src={tabText.washcareImage} alt={tabText.washcareTitle} loading="lazy"
                          className="w-full max-h-64 object-contain rounded-xl bg-white mb-3" />
                      )}

                      {product.washcare && (
                        <p className="text-sm text-gray-700 leading-relaxed mb-3">{product.washcare}</p>
                      )}

                      <ul className="list-disc pl-5 text-sm text-gray-600 space-y-1.5">
                        {tabText.washcareTips.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>

                      <Link
                        to="/wash-care-instructions"
                        className="inline-block mt-3 text-sm font-semibold text-[var(--brand-primary-700)] hover:underline"
                      >
                        {tabText.washcareLink}
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* About section below */}
          <div className="mt-12">
            <About />
          </div>
        </div>

        <OrderPopup
          showPopup={showPopup}
          closePopup={closePopup}
          product={product}
          selectedSize={selectedSize}
          selectedColor={selectedColor}
          count={count}
          currency="₹"
          price={newPrice}
        />

      </div>
    </>
  );
};

export default Products;
